import moment from "moment";

/** The next relevant air date for a series (upcoming preferred, else release). */
function airMoment(series) {
  const raw = series.nextAir || series.release;
  if (!raw) return null;
  const m = moment(raw);
  return m.isValid() ? m : null;
}

/** Orange date label shown above an upcoming card. */
export function upcomingLabel(series) {
  const m = airMoment(series);
  if (!m) return null;

  const days = m.clone().startOf("day").diff(moment().startOf("day"), "days");
  let status;
  if (days === 0) status = "TODAY";
  else if (days === 1) status = "1 day left";
  else if (days > 1) status = `${days} days left`;
  else status = "Aired";

  return {
    month: m.format("MMMM").toUpperCase(),
    day: m.format("'DD"),
    status,
  };
}

/** Whole days from now until the series airs (negative if in the past). */
export function daysUntilAir(series) {
  const m = airMoment(series);
  if (!m) return null;
  return m.clone().startOf("day").diff(moment().startOf("day"), "days");
}

/** Release / first-air year, e.g. "2023". */
export function seriesYear(series) {
  const raw = series.release || series.nextAir;
  const m = raw ? moment(raw) : null;
  return m && m.isValid() ? m.format("YYYY") : "";
}

/** "S 1  E 05" style label, or empty when the data is unavailable. */
export function episodeLabel(series) {
  if (series.season == null || series.episode == null) return "";
  const ep = String(series.episode).padStart(2, "0");
  return `S ${series.season}  E ${ep}`;
}

/** Poster/backdrop URL resolved against the TMDB asset base. */
export function seriesImage(series, prefer) {
  const base = process.env.VUE_APP_TMDB_ASSET ?? "";
  const path =
    prefer === "backdrop"
      ? series.backdrop || series.poster
      : series.poster || series.backdrop;
  return path ? base + path : "";
}
